import { Directive, HostListener, Input, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputFunction]',
  standalone: true,
})
export class DynamicFormDirective {
  readonly control = inject(NgControl);

  @Input('appInputFunction') dynamicFunction?: (value: string) => string;

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    let newValue = value;
    if (this.dynamicFunction) {
      newValue = this.dynamicFunction(newValue);
    }
    this.control.valueAccessor?.writeValue(newValue);
  }
}
